import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { from } from 'rxjs';
import translate from "translate";

@Component({
    selector: 'mono-common-show-hide-password-toggle',
    templateUrl: './show-hide-password-toggle.component.html',
    standalone: true,
    imports: [CommonModule]
})
export class ShowHidePasswordToggleComponent implements OnInit {

  private readonly defaultLanguage = "en";

  @Input() language: string = this.defaultLanguage;
  @Input() disabled?: boolean = false;

  @Output() showToggle = new EventEmitter<boolean>();

  public showPassword = false;
  public showText = from(translate(this.language == this.defaultLanguage ? "show" : "show", this.language));
  public hideText = from(translate(this.language == this.defaultLanguage ? "hide" : "hide", this.language));
  public toggleShowPasswordAriaLabel = from(translate("Show or hide your password on screen", this.language));

  constructor() { }

  ngOnInit(): void {
  }

  public showToggleEmit() {
    this.showPassword = !this.showPassword;
    this.showToggle.emit(this.showPassword);
  }

  public preventFocusOnElement(event: Event) {
    event.preventDefault();
  }

}